/*!!
 * This file contains the following:
 *
 *	jQuery		(C)JS Foundation and other contributors // MIT license.
 * 	asys.js		(C)nabe@abk.
 *
 * See more information https://github.com/nabe-abk/asys.js
 */
'use strict';
